import { UseType } from "./../types/form";
import { useContext, useEffect, useState } from "react";
import useBasicModal from "../BasicModal/useBasicModal";
import { FormContext } from "../FormContextProvider";
import InsuranceService from "../Service/service";
import { VehicleClass } from "../types/form";

export const useVehicles = () => {
  const service = new InsuranceService();
  const [vehicleClass, setVehicleClass] = useState<VehicleClass>(
    VehicleClass.PRIVATE
  );
  const [useType, setUseType] = useState<UseType>(UseType.PERSONAL);
  const { vehicles, setVehicles, viewedPlans } = useContext(FormContext);
  const [loading, setLoading] = useState(true);
  const { show, setShow, setText, text } = useBasicModal();
  const [vehicleList, setList] = useState<any[]>([]);
  const vehicleCategories = {
    [UseType.PERSONAL]: {
      [VehicleClass.PRIVATE]: [100, 105, 210],
      [VehicleClass.PICKUP]: [210],
      [VehicleClass.BIKE]: [400],
    },
    [UseType.COMMERCIAL]: {
      [VehicleClass.PRIVATE]: [100, 105, 200, 210],
      [VehicleClass.PICKUP]: [200, 210],
      [VehicleClass.BIKE]: [400],
    },
  };

  const handleClose = () => {
    setShow(false);
  };

  const loadVehicleData = async () => {
    service
      .getVehicles("1000")
      .then((res) => {
        setVehicles(res.data);
      })
      .catch((err) => {
        setText("Hubo un error al cargar los datos de los vehículos");
        setShow(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const setVehicleList = (useType: UseType, vehicleClass: VehicleClass) => {
    let vehicleList: any[] = [];
    Object.keys(vehicles).forEach((key) => {
      if (vehicleCategories[useType][vehicleClass].includes(Number(key))) {
        vehicles[key].forEach((item: any) => {
          const old = vehicleList.find((i: any) => i.brand === item.brand);
          if (old) {
            item.models.forEach((model: any) => {
              if (!old.models.find((m: any) => m.model === model.model)) {
                old.models.push(model);
              } else {
                old.models.forEach((m: any) => {
                  if (m.model === model.model) {
                    m.version = [...m.version, ...model.version];
                  }
                });
              }
            });
          } else {
            vehicleList.push(item);
          }
        });
      }
    });
    setList(vehicleList);
  };

  const getBrands = () => {
    return vehicleList.map((item: any) => ({
      id: item.brand,
      name: item.brand,
    }));
  };

  const getModels = (brand: string) => {
    return (
      vehicleList
        .find((item: any) => item.brand === brand)
        ?.models.map((model: any) => ({
          id: model.model,
          name: model.model,
        })) || []
    );
  };

  const getVersions = (brand: string, model: string) => {
    const versions =
      vehicleList
        .find((item: any) => item.brand === brand)
        ?.models.find((item: any) => item.model === model)
        ?.version.map((version: any) => ({
          id: version.version,
          name: version.version,
          amis: version.amis,
        })) || [];
    return versions.filter((item: any, index: number) => {
      return versions.findIndex((i: any) => i.id === item.id) === index;
    });
  };

  useEffect(() => {
    if (!viewedPlans) {
      loadVehicleData();
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setVehicleList(useType, vehicleClass);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicles, useType, vehicleClass]);

  return {
    useType,
    vehicleList,
    setVehicleClass,
    vehicleClass,
    setUseType,
    getVersions,
    handleClose,
    getModels,
    getBrands,
    setText,
    setShow,
    loading,
    show,
    text,
  };
};
